import { HEIGHT } from '../../../constants/nonTokenisedValues';
export const setInputAppearance = theme => {
  return Object.assign({
    display: 'block',
    height: HEIGHT.TEXT_AREA_INPUT,
    width: '100%'
  }, theme.typography['body-100'], {
    textAlign: 'left',
    verticalAlign: 'middle',
    color: theme.color['text-core-default'],
    backgroundColor: theme.color['fill-field-default'],
    border: `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`,
    borderRadius: theme.borderRadius['100']
  });
};